
const useStyles = () => {
    return {
        btn:'text-white  border-2 px-6 py-3 my-2 flex items-center hover:bg-rose-500 hover:scale-105 rounded-full ',
        arrow:'ml-3 ',
    };
  }
  
  export default useStyles